import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const SwapIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "swap",
  "SwapIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_644)"><path d="M0.666748 7.99996L5.33342 11.3333L5.33341 8.66665L10.6667 8.66665L10.6667 11.3333L15.3333 7.99998L10.6667 4.66665L10.6667 7.33329L5.33341 7.33329L5.33341 4.66662L0.666748 7.99996Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd"/></g><defs><clipPath id="clip0_19498_644"><rect width="16" height="16" fill={colorList[1]} transform="translate(0 16) rotate(-90)"/></clipPath></defs></g></svg>
);

export default SwapIcon;
